export default __webpack_public_path__ + "static/media/2006.33c99e27.png";